import React from "react";

export default ({ children }) => {
  return <div className='layout-wrapper d-lg-flex'>{children}</div>;
};
